module.exports = __webpack_public_path__ + "img/US_BonusDamagevsCavalry_ua.0f673b26.webp";